module.exports = __webpack_public_path__ + "img/icon-notification-off.3a68feb1.svg";